import GeoPoint from "../Shared/GeoPoint";
import InPersonInterviewAddressType from "./InPersonInterviewAddressType";
import JobWorkerInterviewType from "./JobWorkerInterviewType";

export default class CreateJobWorkerInterviewRequest {
    startAt: Date;
    endAt: Date;
	type: JobWorkerInterviewType = 0;
    contactId = '';
    inPersonAddressType: InPersonInterviewAddressType;
    otherLocationId: string;
    companyAddressId: string;
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    workerInstructions = '';
    contactInstructions = '';
    sendWorkerConfirmation = true;
    sendContactConfirmation = true;

}